<script setup>
// Define a prop for minHeight with a default value of 300
const props = defineProps({
  minHeight: {
    type: Number,
    default: 300,
  },
});
</script>

<template>
  <div
    :class="`flex justify-center items-center`"
    :style="{ minHeight: `${props.minHeight}px` }">
    <span class="inline-block animate-spin">
      <i class="text-30 text-blue ri-loader-4-line"></i>
    </span>
  </div>
</template>
